import { LinkProps, mediaHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { mapIconName } from '../../helpers/mapIconName';
import { mapLinkIconPlacement } from '../../helpers/mapLinkIconPlacement';
import type { OutboundLinkProps } from '../OutboundLink/OutboundLink';
import { OutboundLink } from '../OutboundLink/OutboundLink';
import { IconInfo } from '../types';

const StyledOutboundLink = styled(OutboundLink)`
  ${mediaHelper('mobile')} {
    flex-grow: 1;
  }
`;

export interface ExternalLinkProps extends OutboundLinkProps {
  linkVariant: LinkProps['variant'];
  iconInfo?: IconInfo | null;
  rel?: string;
}

export const ExternalLink: FunctionComponent<PropsWithChildren<ExternalLinkProps>> = ({
  linkVariant,
  iconInfo,
  children,
  rel,
  ...rest
}) => (
  <StyledOutboundLink
    variant={linkVariant}
    sizeVariant="medium"
    icon={mapIconName(iconInfo?.name)}
    iconPlacement={mapLinkIconPlacement(iconInfo?.placement) ?? undefined}
    rel={rel}
    {...rest}
  >
    {children}
  </StyledOutboundLink>
);
